import { Flex, Typography } from "antd";
import { WhiteBoxBlock } from "ui";
import style from "../template.module.css";
import { AddTemplatesFileBtn } from "../AddTemplatesFileBtn";
import { DownloadTemplatesFileBtn } from "../DownloadTemplatesFileBtn";
import { TemplatesCodeBtn } from "../TemplatesCodeBtn";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";

export const OfferTemplateItem = observer(() => {
  const { offerDoc } = useStores();
  return (
    <WhiteBoxBlock className={`bg-basic-200 full-width ${style.templateBoxPadding}`}>
      <Flex justify="space-between">
        <Flex gap={1} vertical>
          <Typography.Text strong>
            Оферта <TemplatesCodeBtn isOffer />
          </Typography.Text>
        </Flex>

        <Flex vertical gap="small">
          <Flex>
            <AddTemplatesFileBtn
              tooltip="Загрузить шаблон оферты"
              fn={({ file }) => offerDoc.uploadOfferDocFile(file)}
              successMessage="Шаблон оферты обновлён"
            />
            <DownloadTemplatesFileBtn tooltip="Скачать шаблон оферты" fn={() => offerDoc.downloadOfferTemplateFile()} />
          </Flex>
        </Flex>
      </Flex>
    </WhiteBoxBlock>
  );
});
